'use strict';

const Vue = require('vue');
const Flyin = require('./flyin/flyin.vue');

const flyinAppEl = '#flyin-app';
const flyinVueEl = '#flyin';
const flyinTrigger = '.js-flyin-trigger';

/**
 * Add events to all flyin triggers
 * The code below also illustrates how to trigger the Flyin
 */
const initTriggers = () => {
    document.querySelectorAll(flyinTrigger).forEach((trigger) => {
        trigger.addEventListener('click', () => {
            window.eventBus.$emit('shouldOpenFlyin', {
                content: '<div class="generic-flyout-header">Add markup here</div>',
                callback: () => {
                    // Add code for callback here...
                }
            });
        }, false);
    });

    document.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
            window.eventBus.$emit('shouldCloseFlyin');
        }
    });
};

/**
 * Setup eventbus to allow Flyin to pass back data
 */
const initEventBus = () => {
    window.eventBus = window.eventBus || new Vue();
    window.eventBus.$on('shouldOpenFlyin', (data) => {
        if (flyInExists(data.id)) {
            return;
        }
        prepareMarkup(data.id);
        createFlyin(data);
    });

    window.eventBus.$on('flyinOpened', (data) => {
        if (data.callback && typeof data.callback === 'function') {
            data.callback();
        }
    });

    window.eventBus.$on('flyinClosed', (id) => {
        destroyFlyin(id);
    });
};

const flyInExists = (id) => document.querySelector([flyinVueEl, id].join(''));

/**
 * Prepares the markup for the Flyin to be attached to
 */
const prepareMarkup = () => {
    const template = `<div id="${flyinAppEl.substring(1)}" />`;
    document.querySelector('body').insertAdjacentHTML('beforeend', template);
};

/**
 * Attaches the Flyin app to the DOM
 */
const createFlyin = (data) => {
    return new Vue({
        el: flyinAppEl,
        store: data.store,
        components: {Flyin},
        computed: {
            config() {
                return data;
            }
        },
        template: `<flyin :config="config" />`
    });
};

/**
 * Removes the Flyin App from the DOM
 */
const destroyFlyin = (id) => {
    const el = document.querySelector([flyinVueEl, id].join(''));
    if (el) {
        el.parentNode.removeChild(el);
    }
};

const flyinApp = {
    init: () => {
        initTriggers();
        initEventBus();
    }
};

module.exports = flyinApp;
